export const EventCurrencyChanged = "coingecko-currency-changed";
export const EventPriceChartReload = "coingecko-price-chart-reload";
export const EventPricePercentageChanged = "coingecko-price-percentage-changed";
export const EventPriceChanged = "coingecko-price-changed";



// WEBPACK FOOTER //
// ./app/assets/webpack/events.js